module.exports = __webpack_public_path__ + "img/6A3C15_EFC898_D59D59_B38346-256px.53379216.png";